<template>
    <div class="selfExamination">
        <div class="top">
            <img class="selfExamination-img" src="../../../assets/images/degreeApplication/selfExamination.png" alt="" />
            <!-- <img class="noticeOfApplication-img" src="../../../assets/images/degreeApplication/noticeOfApplication.png" alt="" @click="goToClick" /> -->
        </div>
        <div class="cont">
            <h1 class="cont-title">申报条件简述 </h1>
            <div class="cont-item cont-top">
                成人高等教育本科毕业生在
                <span class="color-red">
                    毕业后（以毕业证书落款时间为准）两年内
                </span>
                ，对照下列条件后可向继续教育学院提出申请学士学位的申报。
            </div>
            <div class="cont-item cont-1">
               （一）坚持四项基本原则，热爱社会主义祖国，遵纪守法，品行端正。
            </div>
            <div class="cont-item">
               （二）完成本科教学计划的各项要求，能较好地掌握本专业规定的公共课、基础理论课、专业基础课、专业课和基本技能，具有从事科学研究工作或担任专门技术工作的能力，经考核准予毕业。
            </div>
            <div class="cont-item">
                （三）非英语专业本科生通过各省市学位主管部门组织的成人高等教育学士学位外语水平统一考试（2020年1月1日前）；或者自2020年1月1日起通过
                <span class="color-red">以下五种考试之一</span>
                ：
            </div>
            <div class="cont-item cont-3">
                <p>
                    1.全国大学英语
                    <a href="http://cet.neea.edu.cn/" target="_blank">
                        <span class="color-blue">四级考试</span>
                    </a>
                    （简称CET）CET-4成绩355分及以上； 
                </p>
                <p>
                    2.全国
                    <a href="http://pets.neea.edu.cn/" target="_blank">
                        <span class="color-blue">英语等级考试（简称PETS）</span>
                    </a>
                    PETS-3笔试成绩60分及以上； 
                </p>
                <p>
                    3.高等教育自学考试本科段统考课程英语（二）成绩60分及以上； 
                </p>
                <p>
                    4.国际人才英语考试（简称ETIC）ETIC初级成绩良好及以上。
                </p>
                <p>
                    5.全国计算机等级考试（简称NCRE ）二级及以上。
                </p>
            </div>
            <div class="cont-item">
                （四）业余及
                <span class="color-red">函授本科层次</span>
                学生在校学习期间课程
                <span class="color-red">平均成绩在75分</span>
                及以上，高等教育
                <span class="color-red">自学考试本科</span>
                学生课程
                <span class="color-red">平均成绩在65分</span>
                及以上。
            </div>
            <div class="cont-item">
                （五）
                <span class="color-red">毕业论文、毕业设计</span>
                或其他毕业实践环节成绩
                <span class="color-red">达到良好及以上</span>
                （75分及以上）。
            </div>
            <div class="cont-item">
                （六）在校期间无留校察看及以上的处分。
            </div>
        </div>
    </div>
</template>

<script>
// import { getPatch } from "@/api/degreeApplication";
export default {
    name: 'selfExamination',
    data(){
        return {
            url: '',
        }
    },
    created(){
        // this.getData();
    },
    methods: {
        // 获取学位申请通知链接
        // getData(){
        //     let data = {
        //         tag: 'academicDegreeNotice'
        //     }
        //     getPatch(data).then(res => {
        //         this.url = JSON.parse(res.result.content).link;
        //     });
        // },
        //点击本学期学位申请通知
        // goToClick(){
        //     open(this.url, '_blank');
        // },
    },
}
</script>

<style lang="scss" scoped>
.selfExamination{
    padding: 20px;
    .top{
        display: flex;
        .selfExamination-img,
        .noticeOfApplication-img{
            width: 150px;
            height: 100px;
            object-fit: contain;
        }
        .noticeOfApplication-img{
            cursor: pointer;
        }
    }
    .cont{
        font-weight: 700;
        font-size: 11pt;
        margin-top: 20px;
        .cont-title{
            font-weight: 700;
        }
        .cont-top{
            margin-top: 10px;
        }
        .cont-item{
            font-family: -apple-system, "PingFang SC", "Segoe UI", "Microsoft YaHei", STHeiti, "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji";
            line-height: 30px;
            .color-red{
                color: rgb(255, 0, 0);
                font-family: 方正仿宋_GBK, FZFangSong-Z02S, 方正仿宋, FangSong, STFangsong, fangsong;
                background-color: white;
                font-size: 12pt;
            }
            .color-blue{
                font-family: 方正仿宋_GBK, FZFangSong-Z02S, 方正仿宋, FangSong, STFangsong, fangsong;
                font-size: 12pt;
                color: #006dcc;
            }
            &.cont-1{
                margin-top: 25px;
            }
            &.cont-3{
                padding-left: 40px;   
            }
            a:visited {
                color: #006dcc;
            }
            a:active, a:hover {
                color: #33a0ff;
            }
        }
    }
}
</style>